import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=686b0f4b&scoped=true&"
import script from "./Employees.vue?vue&type=script&lang=js&"
export * from "./Employees.vue?vue&type=script&lang=js&"
import style0 from "./Employees.vue?vue&type=style&index=0&id=686b0f4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686b0f4b",
  null
  
)

export default component.exports